export type Theme = "light" | "dark";

const STORAGE_KEY = "aimly-admin-theme";

/** `index.html` dagi skript ham shu kalitni o'qiydi — nomi birga o'zgaradi. */
export function readTheme(): Theme {
  try {
    return localStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function applyTheme(theme: Theme): void {
  document.documentElement.classList.toggle("dark", theme === "dark");
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // Private rejim — mavzu faqat shu sahifa uchun qoladi.
  }
}
